// UI texts for the link page feature (German + English).
import { useAppTranslation } from '../hooks/useAppTranslation.js';

const de: Record<string, string> = {
  "themeCustom": "Eigene",
  "bs_rounded": "Abgerundet",
  "bs_pill": "Pille",
  "bs_square": "Eckig",
  "bs_outline": "Umriss",
  "bs_soft": "Sanft",
  "font_sans": "Sans",
  "font_serif": "Serif",
  "font_rounded": "Rund",
  "font_mono": "Mono",

  "previewEmpty": "Füge deinen ersten Link hinzu, um ihn hier zu sehen.",
  "notFoundTitle": "Seite nicht gefunden",
  "notFoundText": "Diese Link-Seite existiert nicht.",
  "slugInvalid": "Die URL muss 3–40 Zeichen lang sein: Kleinbuchstaben, Zahlen und Bindestriche.",
  "title": "Link-Seiten",
  "slugPlaceholder": "meine-links",
  "copied": "Kopiert",
  "copyUrl": "URL kopieren",
  "titleSingle": "Link-Seite",
  "linkIncomplete": "Jeder Link braucht eine Bezeichnung und eine URL (Überschriften nur eine Bezeichnung).",
  "confirmDelete": "Diese Link-Seite endgültig löschen?",
  "back": "← Zurück",
  "open": "Öffnen ↗",
  "saving": "Speichern…",
  "saved": "Gespeichert",
  "save": "Speichern",
  "profile": "Profil",
  "titleField": "Titel",
  "address": "Adresse",
  "bio": "Bio",
  "uploading": "Lädt hoch…",
  "uploadAvatar": "Avatar hochladen",
  "uploadBanner": "Banner hochladen",
  "bannerHint": "Wird im Karten-Layout oben angezeigt",
  "remove": "Entfernen",
  "displayCircle": "Als Kreis-Icon anzeigen",
  "displayButton": "Als Button anzeigen",
  "toggleMode": "Hell / Dunkel wechseln",
  "share": "Seite teilen",
  "showQr": "QR-Code anzeigen",
  "close": "Schließen",
  "links": "Links",
  "addLink": "+ Link",
  "addHeader": "+ Überschrift",
  "noLinks": "Noch keine Links.",
  "headerText": "Text der Überschrift",
  "label": "Bezeichnung",
  "sectionHeader": "Abschnitts-Überschrift",
  "linkUrl": "Link-URL",
  "icon": "Icon",
  "header": "Überschrift",
  "hideLink": "Link ausblenden",
  "showLink": "Link einblenden",
  "moveUp": "Nach oben",
  "moveDown": "Nach unten",
  "deleteLink": "Link löschen",
  "design": "Design",
  "theme": "Theme",
  "background": "Hintergrund",
  "gradientEnd": "Verlauf bis",
  "text": "Text",
  "buttonColor": "Button-Farbe",
  "buttonStyle": "Button-Stil",
  "font": "Schrift",
  "layout": "Layout",
  "layoutList": "Liste",
  "layoutGrid": "Raster (2 Spalten)",
  "layoutCard": "Karte (mit Banner)",
  "linkColor": "Link-Farbe",
  "linkColorReset": "Standard",
  "linkColorHint": "Eigene Farbe nur für diesen Link",
  "mode": "Hell / Dunkel",
  "modeAuto": "Theme-Standard",
  "modeLight": "Hell",
  "modeDark": "Dunkel",
  "deletePage": "Seite löschen",
  "deletePageHint": "Entfernt die Seite samt Statistik.",
  "delete": "Löschen",
  "livePreview": "Live-Vorschau",
  "intro": "Zusätzliche öffentliche Seiten mit beliebig vielen Links – ergänzend zu deiner Visitenkarte.",
  "newAddress": "Adresse der neuen Seite",
  "createPage": "+ Seite erstellen",
  "emptyList": "Noch keine Link-Seiten. Erstelle oben deine erste.",
  "edit": "Bearbeiten",
  "views": "Aufrufe",
  "clicks": "Klicks",
  "linkCount": "Links",

  "wizBack": "Zurück",
  "wizContinue": "Weiter",
  "wizFinish": "Seite erstellen",
  "wizTitle1": "Was beschreibt dein Ziel\nam besten?",
  "wizSub1": "Das hilft uns, dein Erlebnis zu personalisieren.",
  "wizTitle2": "Was möchtest du mit deiner\nLink-Seite tun?",
  "wizSub2": "Wähle so viele wie du magst.",
  "wizTitle3": "Auf welchen Plattformen bist du?",
  "wizSub3": "Wähle bis zu fünf zum Start. Du kannst sie jederzeit ändern.",
  "wizTitle4": "Füge deine Links hinzu",
  "wizSub4": "Fülle die Felder aus, um Inhalte zu deiner neuen Link-Seite hinzuzufügen.",
  "wizTitle5": "Wähle ein Theme",
  "wizSub5": "Wähle den Stil, der passt – Inhalte kannst du später ändern.",
  "wizGoal_creator": "Creator",
  "wizGoal_creator_desc": "Meine Follower aufbauen und Wege finden, mein Publikum zu monetarisieren.",
  "wizGoal_business": "Business",
  "wizGoal_business_desc": "Mein Geschäft ausbauen und mehr Kunden erreichen.",
  "wizGoal_personal": "Persönlich",
  "wizGoal_personal_desc": "Links mit Freunden und Bekannten teilen.",
  "wizIntent_share": "Meine Inhalte mit einem schicken Link in Bio teilen",
  "wizIntent_earn": "Geld verdienen oder Produkte bewerben",
  "wizIntent_grow": "Mein Publikum mit besseren Tools und Einblicken vergrößern",
  "wizIntent_else": "Etwas anderes…",
  "wizAddress": "Adresse der Seite",
  "wizTitlePlaceholder": "Titel (optional)",
  "wizYourSelections": "Deine Auswahl",
  "wizAdditionalLinks": "Weitere Links",
  "wizLimit": "Dein Plan enthält keine weitere Link-Seite. Bitte upgrade deinen Plan.",
  "wizSlugChecking": "Prüfe Verfügbarkeit…",
  "wizSlugAvailable": "Verfügbar",
  "wizSlugTaken": "Schon vergeben – bitte eine andere Adresse wählen.",
  "wizCreateWithWizard": "Mit Assistenten erstellen"
};

const en: Record<string, string> = {
  "themeCustom": "Custom",
  "bs_rounded": "Rounded",
  "bs_pill": "Pill",
  "bs_square": "Square",
  "bs_outline": "Outline",
  "bs_soft": "Soft",
  "font_sans": "Sans",
  "font_serif": "Serif",
  "font_rounded": "Rounded",
  "font_mono": "Mono",

  "previewEmpty": "Add your first link to see it here.",
  "notFoundTitle": "Page not found",
  "notFoundText": "This link page does not exist.",
  "slugInvalid": "The URL must be 3–40 characters: lowercase letters, numbers and hyphens.",
  "title": "Link pages",
  "slugPlaceholder": "my-links",
  "copied": "Copied",
  "copyUrl": "Copy URL",
  "titleSingle": "Link page",
  "linkIncomplete": "Every link needs a label and a URL (headers only need a label).",
  "confirmDelete": "Delete this link page permanently?",
  "back": "← Back",
  "open": "Open ↗",
  "saving": "Saving…",
  "saved": "Saved",
  "save": "Save",
  "profile": "Profile",
  "titleField": "Title",
  "address": "Address",
  "bio": "Bio",
  "uploading": "Uploading…",
  "uploadAvatar": "Upload avatar",
  "uploadBanner": "Upload banner",
  "bannerHint": "Shown at the top of the card layout",
  "remove": "Remove",
  "displayCircle": "Show as circle icon",
  "displayButton": "Show as button",
  "toggleMode": "Toggle light / dark",
  "share": "Share page",
  "showQr": "Show QR code",
  "close": "Close",
  "links": "Links",
  "addLink": "+ Link",
  "addHeader": "+ Header",
  "noLinks": "No links yet.",
  "headerText": "Header text",
  "label": "Label",
  "sectionHeader": "Section header",
  "linkUrl": "Link URL",
  "icon": "Icon",
  "header": "Header",
  "hideLink": "Hide link",
  "showLink": "Show link",
  "moveUp": "Move up",
  "moveDown": "Move down",
  "deleteLink": "Delete link",
  "design": "Design",
  "theme": "Theme",
  "background": "Background",
  "gradientEnd": "Gradient end",
  "text": "Text",
  "buttonColor": "Button colour",
  "buttonStyle": "Button style",
  "font": "Font",
  "layout": "Layout",
  "layoutList": "List",
  "layoutGrid": "Grid (2 columns)",
  "layoutCard": "Card (with banner)",
  "linkColor": "Link colour",
  "linkColorReset": "Default",
  "linkColorHint": "Custom colour for this link only",
  "mode": "Light / dark",
  "modeAuto": "Theme default",
  "modeLight": "Light",
  "modeDark": "Dark",
  "deletePage": "Delete page",
  "deletePageHint": "Removes the page and its statistics.",
  "delete": "Delete",
  "livePreview": "Live preview",
  "intro": "Additional public pages with any number of links – alongside your contact card.",
  "newAddress": "Address of the new page",
  "createPage": "+ Create page",
  "emptyList": "No link pages yet. Create your first one above.",
  "edit": "Edit",
  "views": "views",
  "clicks": "clicks",
  "linkCount": "links",

  "wizBack": "Back",
  "wizContinue": "Continue",
  "wizFinish": "Create page",
  "wizTitle1": "Which best describes\nyour goal?",
  "wizSub1": "This helps us personalize your experience.",
  "wizTitle2": "What would you like to\ndo with your link page?",
  "wizSub2": "Choose as many as you like.",
  "wizTitle3": "Which platforms are you on?",
  "wizSub3": "Pick up to five to get started. You can update them at any time.",
  "wizTitle4": "Add your links",
  "wizSub4": "Complete the fields below to add content to your new link page.",
  "wizTitle5": "Select a theme",
  "wizSub5": "Pick the style that feels right – you can change your content later.",
  "wizGoal_creator": "Creator",
  "wizGoal_creator_desc": "Build my following and explore ways to monetize my audience.",
  "wizGoal_business": "Business",
  "wizGoal_business_desc": "Grow my business and reach more customers.",
  "wizGoal_personal": "Personal",
  "wizGoal_personal_desc": "Share links with my friends and acquaintances.",
  "wizIntent_share": "Share my content with a great-looking link in bio",
  "wizIntent_earn": "Earn money or promote things I'm selling",
  "wizIntent_grow": "Grow my audience with better tools and insights",
  "wizIntent_else": "Something else…",
  "wizAddress": "Page address",
  "wizTitlePlaceholder": "Title (optional)",
  "wizYourSelections": "Your selections",
  "wizAdditionalLinks": "Additional links",
  "wizLimit": "Your plan does not include another link page. Please upgrade your plan.",
  "wizSlugChecking": "Checking availability…",
  "wizSlugAvailable": "Available",
  "wizSlugTaken": "Already taken – please choose a different address.",
  "wizCreateWithWizard": "Create with wizard"
};

/** Returns a lookup function for the current UI language (German by default, like the rest of the dashboard). */
export function useLP(): (key: string) => string {
  const { i18n } = useAppTranslation();
  const dict = (i18n?.language ?? 'de').toLowerCase().startsWith('en') ? en : de;
  return (key: string) => dict[key] ?? de[key] ?? key;
}
